import { createFileRoute, Link } from "@tanstack/react-router";
import { buildSeo } from "@/lib/seo";
import { DocsPageShell, type DocBlock } from "@/components/marketing/DocsLayout";

const blocks: DocBlock[] = [
  {
    type: "p",
    text: "Your knowledge is your competitive edge, so isolation and honest data handling are built in, not bolted on.",
  },
  { type: "h2", text: "Where data lives" },
  {
    type: "p",
    text: "Application data is hosted in the European Union (Ireland). Reality Twin is a Swiss company governed by Swiss law; the data is stored in the EU under the GDPR and the Swiss FADP.",
  },
  { type: "h2", text: "Isolation" },
  {
    type: "ul",
    items: [
      "Every workspace's knowledge is isolated at the database row level with Row-Level Security.",
      "We never train shared foundation models on your content.",
      "Bank/payout details live in a separate private table and are never shown on public profiles or quotes.",
    ],
  },
  { type: "h2", text: "Access control" },
  {
    type: "ul",
    items: [
      "Only accounts you invite to your workspace can access it; roles are owner, admin and member.",
      "Operator access on our side is protected by MFA, restricted to the founder, and audit-logged.",
      "Public endpoints (chat, embed, MCP) are rate-limited and fail closed.",
    ],
  },
  { type: "h2", text: "Compliance" },
  {
    type: "p",
    text: (
      <>
        Reality Twin is aligned with the GDPR and the Swiss FADP. A signed DPA and the list of
        sub-processors are available — see{" "}
        <Link to="/dpa" className="underline">
          /dpa
        </Link>{" "}
        and{" "}
        <Link to="/security" className="underline">
          /security
        </Link>
        , or request the DPA at hello@realitytwin.io.
      </>
    ),
  },
  {
    type: "callout",
    title: "Data export & deletion",
    text: "You can export your data at any time. If you cancel, your data stays available for export for 30 days before deletion.",
  },
];

export const Route = createFileRoute("/docs/security")({
  head: () =>
    buildSeo({
      path: "/docs/security",
      title: "Security & Data — Reality Twin Docs",
      description: "Hosting, row-level isolation, access control, GDPR/FADP alignment and the DPA.",
    }),
  component: () => (
    <DocsPageShell
      slug="security"
      title="Security & data"
      description="Hosting, isolation, access control, GDPR/FADP and the DPA."
      blocks={blocks}
    />
  ),
});
